(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function parseRestrictedVariantIds(ids) {
    if (!ids) return [];
    return ids
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(function (id) { return id.length > 0; });
  }

  function parseMinOrderQuantities(mapString) {
    var result = {};
    if (!mapString) return result;
    mapString.split(';').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) {
        var id = parts[0].trim();
        var qty = parseInt(parts[1].trim(), 10);
        if (id && !isNaN(qty)) {
          result[id] = qty;
        }
      }
    });
    return result;
  }

  function getProductInfoElement(sectionId) {
    return document.querySelector('product-info[data-section="' + sectionId + '"]');
  }

  function getMinOrderQuantityForVariant(productInfo, variantId) {
    var minMapString = productInfo.getAttribute('data-min-order-quantities');
    var minMap = parseMinOrderQuantities(minMapString);
    return minMap[String(variantId)];
  }

  // Ensures we have a reusable MOQ message element above the buy buttons
  function ensureMinQuantityMessage(sectionId) {
    var productInfo = getProductInfoElement(sectionId);
    if (!productInfo) return null;

    var productForm = productInfo.querySelector('product-form');
    if (!productForm) return null;

    var wrapper = productForm.parentElement;
    if (!wrapper) return null;

    var existing = wrapper.querySelector('.min-quantity-message');
    if (existing) return existing;

    var msg = document.createElement('p');
    msg.className = 'min-quantity-message';
    msg.setAttribute('role', 'status');
    msg.style.display = 'none';

    wrapper.insertBefore(msg, productForm);

    return msg;
  }

  function updateRestrictedState(sectionId, variantId) {
    var productInfo = getProductInfoElement(sectionId);
    if (!productInfo) {
      return false;
    }

    var restrictedIds = parseRestrictedVariantIds(
      productInfo.getAttribute('data-restricted-variant-ids')
    );

    var isRestricted = restrictedIds.indexOf(String(variantId)) !== -1;

    var productForm = productInfo.querySelector('product-form');
    if (!productForm) {
      return isRestricted;
    }

    var buyButtonsWrapper = productForm.parentElement;
    var submitButton = buyButtonsWrapper.querySelector('.product-form__submit');
    var paymentButton = buyButtonsWrapper.querySelector('.shopify-payment-button');
    var quantityForm = productInfo.querySelector('#Quantity-Form-' + sectionId);

    var restrictedMessage = buyButtonsWrapper.querySelector('.product-buy-buttons__restricted');
    if (!restrictedMessage) {
      restrictedMessage = document.createElement('p');
      restrictedMessage.className = 'product-buy-buttons__restricted';
      restrictedMessage.setAttribute('role', 'status');
      restrictedMessage.style.display = 'none';

      var messageText = productInfo.getAttribute('data-restricted-message') ||
        'This variant is not available for retail purchase.';

      var textNode = document.createTextNode(messageText + ' ');
      restrictedMessage.appendChild(textNode);

      var link = document.createElement('a');
      link.className = 'product-buy-buttons__restricted-link';
      link.href = productInfo.getAttribute('data-restricted-url') ||
        ((window.routes && window.routes.contact_url) ? window.routes.contact_url : '/contact');

      var linkLabel = productInfo.getAttribute('data-restricted-link-label') ||
        'Submit a trade application to request access';
      link.textContent = linkLabel;

      restrictedMessage.appendChild(link);
      buyButtonsWrapper.insertBefore(restrictedMessage, productForm);
    }

    // Also manage min-quantity message visibility with restriction
    var minMsg = buyButtonsWrapper.querySelector('.min-quantity-message');

    if (isRestricted) {
      restrictedMessage.style.display = '';

      if (submitButton) submitButton.style.display = 'none';
      if (paymentButton) paymentButton.style.display = 'none';
      if (quantityForm) quantityForm.style.display = 'none';
      if (minMsg) {
        minMsg.style.display = 'none';
      }
    } else {
      restrictedMessage.style.display = 'none';

      if (submitButton) submitButton.style.display = '';
      if (paymentButton) paymentButton.style.display = '';
      if (quantityForm) quantityForm.style.display = '';
      // Only re-show minMsg if it has some text; actual content is updated by MOQ code
      if (minMsg && minMsg.textContent.trim() !== '') {
        minMsg.style.display = '';
      }
    }

    return isRestricted;
  }

  // Reset MOQ-specific UI back to the variant's original quantity_rule min
  // WITHOUT changing whether buttons are visible (that is handled by restriction/MOQ logic).
  function resetMinOrderQuantityUI(sectionId) {
    var productInfo = getProductInfoElement(sectionId);
    if (!productInfo) return;

    var quantityInput = productInfo.querySelector('.quantity__input');
    if (!quantityInput) return;

    var minFromRule = quantityInput.getAttribute('data-original-min');
    if (!minFromRule) {
      minFromRule = quantityInput.getAttribute('data-rule-min');
    }

    if (minFromRule) {
      quantityInput.setAttribute('data-min', minFromRule);
      quantityInput.setAttribute('min', minFromRule);
      if (!quantityInput.value || parseInt(quantityInput.value, 10) < parseInt(minFromRule, 10)) {
        quantityInput.value = minFromRule;
      }
    }

    var productForm = productInfo.querySelector('product-form');
    if (!productForm) return;
    var buyButtonsWrapper = productForm.parentElement;
    if (!buyButtonsWrapper) return;

    var minMsg = buyButtonsWrapper.querySelector('.min-quantity-message');
    if (minMsg) {
      minMsg.textContent = '';
      minMsg.style.display = 'none';
    }

    var rulesContainer = productInfo.querySelector('#Quantity-Rules-' + sectionId);
    if (rulesContainer) {
      var minimumSpans = Array.prototype.slice.call(
        rulesContainer.querySelectorAll('.divider')
      ).filter(function (el) {
        return el.textContent.toLowerCase().indexOf('minimum') !== -1;
      });
      if (minimumSpans.length > 0 && minFromRule) {
        minimumSpans[0].textContent = 'Minimum of ' + minFromRule;
      }
    }
  }

  function updateMinOrderQuantity(sectionId, variantId) {
    var productInfo = getProductInfoElement(sectionId);
    if (!productInfo) {
      return;
    }

    var minQty = getMinOrderQuantityForVariant(productInfo, variantId);

    // Do not touch MOQ UI if this variant is restricted;
    // restriction logic already hides quantity + buttons.
    var restrictedIds = parseRestrictedVariantIds(
      productInfo.getAttribute('data-restricted-variant-ids')
    );
    var isRestricted = restrictedIds.indexOf(String(variantId)) !== -1;
    if (isRestricted) {
      return;
    }

    // No MOQ for this variant: reset UI to default quantity_rule min
    if (!minQty || minQty < 1) {
      resetMinOrderQuantityUI(sectionId);
      return;
    }

    var quantityInput = productInfo.querySelector('.quantity__input');
    if (!quantityInput) {
      return;
    }

    // Store original min once from the variant's quantity_rule
    if (!quantityInput.getAttribute('data-original-min')) {
      var ruleMin = quantityInput.getAttribute('min') || quantityInput.getAttribute('data-min') || '1';
      quantityInput.setAttribute('data-original-min', ruleMin);
      quantityInput.setAttribute('data-rule-min', ruleMin);
    }

    // Apply MOQ as the effective min
    quantityInput.setAttribute('data-min', String(minQty));
    quantityInput.setAttribute('min', String(minQty));

    var currentValue = parseInt(quantityInput.value, 10);
    if (isNaN(currentValue) || currentValue < minQty) {
      quantityInput.value = String(minQty);
    }

    if (minQty > 1) {
      var minMsg = ensureMinQuantityMessage(sectionId);
      if (minMsg) {
        var infoTemplate = productInfo.getAttribute('data-min-qty-info-template') ||
          'Minimum order quantity for this variant is __QTY__.';
        minMsg.textContent = infoTemplate.replace('__QTY__', minQty);
        minMsg.style.display = '';
      }
    }

    var rulesContainer = productInfo.querySelector('#Quantity-Rules-' + sectionId);
    if (rulesContainer) {
      var minimumSpans = Array.prototype.slice.call(
        rulesContainer.querySelectorAll('.divider')
      ).filter(function (el) {
        return el.textContent.toLowerCase().indexOf('minimum') !== -1;
      });
      if (minimumSpans.length > 0) {
        minimumSpans[0].textContent = 'Minimum of ' + minQty;
      }
    }
  }

  function updateButtonsForQuantity(sectionId, variantId) {
    var productInfo = getProductInfoElement(sectionId);
    if (!productInfo) return;

    // If restricted, never change button visibility here
    var restrictedIds = parseRestrictedVariantIds(
      productInfo.getAttribute('data-restricted-variant-ids')
    );
    var isRestricted = restrictedIds.indexOf(String(variantId)) !== -1;
    if (isRestricted) {
      return;
    }

    var minQty = getMinOrderQuantityForVariant(productInfo, variantId);

    // If no MOQ, reset to base state (but still allow restriction logic
    // and default theme logic to decide about buttons)
    if (!minQty || minQty < 1) {
      resetMinOrderQuantityUI(sectionId);
      return;
    }

    var quantityInput = productInfo.querySelector('.quantity__input');
    if (!quantityInput) return;

    var productForm = productInfo.querySelector('product-form');
    if (!productForm) return;
    var buyButtonsWrapper = productForm.parentElement;
    if (!buyButtonsWrapper) return;

    var submitButton = buyButtonsWrapper.querySelector('.product-form__submit');
    var paymentButton = buyButtonsWrapper.querySelector('.shopify-payment-button');

    var currentValue = parseInt(quantityInput.value, 10);
    var belowMin = isNaN(currentValue) || currentValue < minQty;

    var minMsg = ensureMinQuantityMessage(sectionId);
    if (minMsg && minQty > 1) {
      var infoTemplate = productInfo.getAttribute('data-min-qty-info-template') ||
        'Minimum order quantity for this variant is __QTY__.';
      var warningTemplate = productInfo.getAttribute('data-min-qty-warning-template') ||
        'Minimum order quantity for this variant is __QTY__. Please increase the quantity to proceed.';

      if (belowMin) {
        minMsg.textContent = warningTemplate.replace('__QTY__', minQty);
        minMsg.style.display = '';
      } else {
        minMsg.textContent = infoTemplate.replace('__QTY__', minQty);
        minMsg.style.display = '';
      }
    }

    if (belowMin) {
      if (submitButton) submitButton.style.display = 'none';
      if (paymentButton) paymentButton.style.display = 'none';
    } else {
      if (submitButton) submitButton.style.display = '';
      if (paymentButton) paymentButton.style.display = '';
    }
  }

  // Toggle the AEP free shipping note vs the shipping policy link for the
  // selected variant. Dawn's product-info.js does not re-render .product__tax
  // on variant change, so this has to be done here.
  function updateShippingNote(sectionId, variantId) {
    var productInfo = getProductInfoElement(sectionId);
    if (!productInfo) return;

    var note = productInfo.querySelector('#ShippingNote-' + sectionId);
    if (!note) return;

    // Reuses the generic comma-separated ID parser
    var freeIds = parseRestrictedVariantIds(
      productInfo.getAttribute('data-free-shipping-variant-ids')
    );
    var isFree = freeIds.indexOf(String(variantId)) !== -1;

    var freeEl = note.querySelector('[data-shipping-note="free"]');
    var policyEl = note.querySelector('[data-shipping-note="policy"]');

    if (freeEl) freeEl.classList.toggle('hidden', !isFree);
    if (policyEl) policyEl.classList.toggle('hidden', isFree);
  }

  function updateVariantDependentState(sectionId, variantId) {
    // 1. Restriction (may hide everything)
    var isRestricted = updateRestrictedState(sectionId, variantId);
    // 2. MOQ logic (skips itself if restricted)
    updateMinOrderQuantity(sectionId, variantId);
    updateButtonsForQuantity(sectionId, variantId);
    // 3. Shipping note (independent of restriction/MOQ)
    updateShippingNote(sectionId, variantId);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var productInfos = document.querySelectorAll('product-info[data-section]');
    productInfos.forEach(function (productInfo) {
      var sectionId = productInfo.getAttribute('data-section');
      if (!sectionId) return;

      var quantityInput = productInfo.querySelector('.quantity__input');
      if (quantityInput && !quantityInput.getAttribute('data-original-min')) {
        var ruleMin = quantityInput.getAttribute('min') || quantityInput.getAttribute('data-min') || '1';
        quantityInput.setAttribute('data-original-min', ruleMin);
        quantityInput.setAttribute('data-rule-min', ruleMin);
      }

      var variantInput = productInfo.querySelector('input.product-variant-id');
      if (!variantInput) {
        return;
      }

      // Initial state
      if (variantInput.value) {
        updateVariantDependentState(sectionId, variantInput.value);
      }

      // Observe variant changes
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            var newValue = variantInput.value;
            if (newValue) {
              updateVariantDependentState(sectionId, newValue);
            }
          }
        });
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Watch quantity input changes
      var qtyInput = productInfo.querySelector('.quantity__input');
      if (qtyInput) {
        ['input', 'change'].forEach(function (evtName) {
          qtyInput.addEventListener(evtName, function () {
            var currentVariantId = variantInput.value;
            if (!currentVariantId) return;
            updateButtonsForQuantity(sectionId, currentVariantId);
          });
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
